import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Company, UserProfile } from '../interfaces/company-settings.interface';
import { AuthService } from 'src/app/auth/auth.service';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LocalStorageKeys } from 'src/app/core/enums/LocalStorageKeys';

@Injectable({
  providedIn: 'root',
})
export class MyAccountService {
  private readonly apiUrl = environment.identity_url;

  userDetail = new BehaviorSubject<UserProfile | null>(null);

  private readonly userDetailSubject = new BehaviorSubject<UserProfile | null>(null);

  private readonly userUpdatedSubject = new Subject<UserProfile>();
  userUpdated$ = this.userUpdatedSubject.asObservable();


  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService,
    private readonly LocalStorageService: LocalStorageService
  ) { }

  getUserDetailLocal(): UserProfile | null {
    return this.LocalStorageService.get(LocalStorageKeys.UserData);;
  }
  setUserDetailLocal(user: UserProfile): void {
    this.LocalStorageService.set(LocalStorageKeys.UserData, user);
    this.userUpdatedSubject.next(user);
  }

  // private getAuthHeaders(): Observable<HttpHeaders> {
  //   return from(this.authService.getAccessToken()).pipe(
  //     map((token) => {
  //       if (!token) {
  //         throw new Error('Failed to acquire token');
  //       }
  //       return new HttpHeaders({
  //         Authorization: `Bearer ${token}`,
  //       });
  //     })
  //   );
  // }

  getCompanyData(): Observable<Company> {
    return this.http.get<Company>(`${this.apiUrl}/user/me/business`)
  }

  getUserDetail(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.apiUrl}/user/me`).pipe(shareReplay(1))
  }

  updateCompanyData(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/user/me/business`, data)
  }

  updateUserData(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/user/me`, data);
  }
}
